<template>
  <div>
    <input :id="playerName" :ref="playerName" type="number" v-model.lazy="myScore" v-on:change="updateActive" required v-focus placeholder="0">
  </div>
</template>

<script>

export default {
  name: "playerscore",
  data: function() {
    return {
      theScore: Number
    }
  },
  props: {
    currentScore: Object,
    playerName: String,
    gameId: String,
    claimFocus: Boolean,
  },
  computed: {
    myScore: {
      get: function() {
        return this.currentScore ? this.currentScore.score : ""
      },
      set: function(newValue) {
        this.theScore = newValue
      }
    }
  },
  methods: {
    updateActive() {
      const data = {
        id: this.gameId,
        player: this.playerName,
        score: this.theScore
      };
 
      this.$store.dispatch('game/updateScore', data)
    }

  },
  mounted() {
    if (this.claimFocus) {
      this.$nextTick(() => this.$refs[this.playerName].focus())
    }
  }
};
</script>

<style scoped>
:invalid {
  border-color: #b00000;
}

:valid {
  border-color: green;
}

input {
  width: 60px;
  border-style: solid;
  border-radius: 2px;
  border-width: thin;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
  text-align: center
}
input[type=number]:focus {
        background-color: #ffffff; 
        color: #000;
      }
</style>